import { useEffect, useMemo } from "react";
import PlayitasNav from "./components/PlayitasNav";
import PlayitasHero from "./components/PlayitasHero";
import PlayitasAbout from "./components/PlayitasAbout";
import PlayitasFacilities from "./components/PlayitasFacilities";
import PlayitasAccommodation from "./components/PlayitasAccommodation";
import PlayitasBenefits from "./components/PlayitasBenefits";
import PlayitasContact from "./components/PlayitasContact";
import SEOJsonLd from "../../components/base/SEOJsonLd";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://meethiszpania.com";

export default function PlayitasPage() {
  useEffect(() => {
    document.title = "Playitas Resort - Strefa B2B dla polskich agencji | Fuerteventura";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute("content", "Strefa B2B Playitas Resort na Fuerteventurze. Materiały sprzedażowe i wsparcie dla polskich agencji turystycznych.");
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", `${SITE_URL}/playitas`);
  }, []);

  const jsonLd = useMemo(() => ([
    {
      "@context": "https://schema.org",
      "@type": "LodgingBusiness",
      "name": "Playitas Resort",
      "url": `${SITE_URL}/playitas`,
      "description": "Playitas Resort na Fuerteventurze – strefa B2B dla polskich agencji turystycznych. Materiały sprzedażowe, oferty pobytów i wsparcie logistyczne.",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Las Playitas",
        "addressRegion": "Fuerteventura",
        "addressCountry": "ES"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "28.1554",
        "longitude": "-14.0297"
      },
      "amenityFeature": [
        { "@type": "LocationFeatureSpecification", "name": "Sports Center", "value": true },
        { "@type": "LocationFeatureSpecification", "name": "Beach Access", "value": true },
        { "@type": "LocationFeatureSpecification", "name": "Spa & Wellness", "value": true },
        { "@type": "LocationFeatureSpecification", "name": "Kids Club", "value": true }
      ],
      "audience": {
        "@type": "Audience",
        "audienceType": "B2B Travel Agencies"
      },
      "inLanguage": "pl"
    },
    {
      "@context": "https://schema.org",
      "@type": "TouristAttraction",
      "name": "Playitas Resort – Fuerteventura",
      "url": `${SITE_URL}/playitas`,
      "description": "Resort Playitas na Fuerteventurze – idealny dla aktywnych turystów, rodzin i grup. Centrum sportowe, plaża i kompleks wellness.",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Las Playitas",
        "addressRegion": "Fuerteventura",
        "addressCountry": "ES"
      },
      "touristType": ["Active Tourism", "Family Tourism", "B2B Travel", "Sports Tourism"]
    }
  ]), []);

  return (
    <div className="min-h-screen bg-white font-sans">
      <SEOJsonLd data={jsonLd} id="jsonld-playitas" />
      <PlayitasNav />
      <PlayitasHero />
      <PlayitasAbout />
      <PlayitasFacilities />
      <PlayitasAccommodation />
      <PlayitasBenefits />
      <PlayitasContact />
    </div>
  );
}